jQuery(document).ready(function ($) {

    const $toggle = $(".js-search-toggle");
    const $form = $(".js-header-search");

    if (!$toggle.length || !$form.length) {
        return;
    }

    $toggle.on("click", function () {
        const isOpen = $form.hasClass('is-visible');

        $form.toggleClass('is-visible', !isOpen);
        $(this).attr("aria-expanded", !isOpen);

        if (!isOpen) {
            $form.find("input[type='search']").trigger("focus");
        }

        return false;
    });

});
